import { Component } from 'react';
import styled from '@emotion/styled';


/**** SINGLE WARRANTY DESKTOP COMPONENTS ***/
export const FlexWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 100%;
`;

export const WarrantyType = styled.div`
    height: 33px;
    text-align: center;
    background-color: ${props => (props.bgColor)};
    width: 100%;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    padding-top: 7px;
    :hover {
        background-color: ${props => (props.bgHover)};
    }
`;

export const SpecificWarranty = styled.div`
    display: flex;
    width: 100%;
    height: 86px;
    background-color: ${props => (props.bgColor)};
    :hover {
        background-color: ${props => (props.bgHover)};
    }
    justify-content: center;
    align-items: center;
`;

export const StandardLogoText = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: #000;
    font-family: 'Source Sans Pro', sans-serif;
`;

export const TPRSLogo = styled.img`
    width: 130px;
    height: auto;
`;
export const SystemProtectionLogo = styled.img`
    width: 130px;
    height: auto;
`;
export const PreferredProtectionLogo = styled.img`
    width: 130px;
    height: auto;
`;
export const PlatinumProtectionLogo = styled.img`
    width: 130px;
    height: auto;
`;

export const StandardWarrantyTitle = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: #000;
`;



export const WarrantyDetailsTable = styled.div`
    display: flex;
`;

export const WarrantyDetailsCol = styled.div`
    display: flex;
    flex-grow: 1;
    flex-basis: 50%;
    flex-direction: column;
`;

export const WarrantyDetailsHeader = styled.div`
    height: 33px;
    background-color: #dadada;
    font-family: OCRoboto;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    text-align: left;
    padding: 10px 0px 0px 10px;
    border-right: 1px solid #cbcbcb;
`;

export const WarrantyDetail = styled.div`
    border-bottom: 1px solid #cbcbcb;
    font-size: 12px;
    color: #000000;
    display: flex;
    flex-grow: ${props => (props.flexGrowValue) };
`;

export const WarrantyDetailName = styled.div`
    width: 50%;
    background-color: #fff;
    font-family: OCRoboto;
    color:#333;
    padding: 10px;
    text-align: right;
`;

export const WarrantyDetailValue = styled.div`
    width: 50%;
    background-color: ${props => (props.bgColor)};
    padding: 10px;
    border-right: 1px solid #cbcbcb;
`;

export const Disclaimer = styled.div`
    min-height: 75px;
    opacity: 0.7;
    font-family: OCRoboto;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    width: 100%;
    padding-top: 7px;
    padding-left: 10px;
    display: block;
`;



/*** MULTIPLE WARRANTY DESKTOP COMPONENTS ****/

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 100%;
`;

export const FlexCol = styled.div`
    display: flex;
    flex-direction: column;
`;


export const WarrantyTableHeader = styled(FlexRow)`
    height: 119px;
`;
export const EmptyGridCorner = styled(FlexCol)`
    flex-grow: ${props => props.flexGrowValue};
    background-color: #fff;
`;
export const CoverageWarrantyWrapper = styled(FlexCol)`
    flex-grow: ${props => props.flexGrowValue};
`;


export const CoverageWrapper = styled(FlexRow)`
    background-color: ${props => props.bgColor};
    flex-basis: 38.5%;
    justify-content: center;
    align-items: center;
`;
export const WarrantiesWrapper = styled(FlexRow)`
    background-color: ${props => props.bgColor};
`;

export const CoverageHeader = styled.span`
    font-family: OCRoboto;
    font-size: 16px;
    color: #000;
`;


export const CategoryHeader = styled(FlexRow)`
    flex: 1 100%;
    height: 33px;
    font-family: OCRoboto;
    font-size: 13px;
    font-weight: bold;
    color: #000;
    justify-content: left;
    align-items: center;
    background-color: #dadada;
    padding-left: 15px;
`;
